export default "__VITE_ASSET__1ab78776__"